import React, { useContext } from 'react';

import AppContext from '../../context/AppContext';
import { langLevels } from '../../helpers/AppHelpers';
import ProjectsSection from './ProjectsSection';
import Certifications from './Certifications';
import UserSummary from './UserSummary';
import SkillsTextSection from './SkillsTextSection';
import Education from './Education';
import ProfessionalSkills from './ProfessionalSkills';

const Hays = () => {
  const context = useContext(AppContext);
  const { state } = context;
  const { data, theme } = state;

  return (
    <div style={{ fontFamily: `"Mulish", sans-serif`, backgroundColor: theme.colors.background, color: theme.colors.primary, }}    >
      <div className="grid grid-cols-12">
        <div className="col-span-5 px-10 py-10 pb-4">
          <div className="text-base font-medium uppercase">
            <span>{data.summary.position_level !== 'Junior' && data.summary.position_level !== 'Middle'
              ? data.summary.position_level + (' ') : ''}</span>
            <span>{data.summary.position}</span>
          </div>
        </div>
        <div className="col-span-7"></div>
        <div className="col-span-5 px-10 py-10 pt-3" style={{ borderRight: "2px solid #c63031" }}>
          <Education data={data} />
          <SkillsTextSection data={data} sectionKey="languages" title="Languages" itemRenderer={(item) => `${item.key}${item.level ? ` — ${langLevels.find(l => l.key === item.level).level}` : ''}`} />
          <SkillsTextSection data={data} sectionKey="domains" title="Domains" itemRenderer={(item) => item.title || item.name} />
          <Certifications data={data} />
        </div>
        <div className="col-span-7 px-6 py-6  pt-3">
          <UserSummary data={data} />
          <SkillsTextSection data={data} sectionKey="programmingLanguages" title="Programming languages" />
          <SkillsTextSection data={data} sectionKey="ideOrTools" title="IDE/Development Tools" />
          <SkillsTextSection data={data} sectionKey="developmentTechnologies" title="Development Technologies" />
          <SkillsTextSection data={data} sectionKey="ciCdTools" title="CI/CD Tools" />
          <SkillsTextSection data={data} sectionKey="versionControlSystems" title="Version Control Systems" />
          <SkillsTextSection data={data} sectionKey="iOsTechnologies" title="iOS Technologies" />
          <SkillsTextSection data={data} sectionKey="androidTechnologies" title="Android Technologies" />
          <SkillsTextSection data={data} sectionKey="developmentMethodologies" title="Development Methodologies" />
          <SkillsTextSection data={data} sectionKey="dataBases" title="Databases" />
        </div>

        <ProjectsSection data={data} />
        <ProfessionalSkills data={data} />
      </div>
    </div>
  );
};

export default Hays;
